import { GuiBase } from "../GuiBase";

export class GuiLogin extends GuiBase {

    constructor() {
        super("Login");
    }

}
